import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { Html, RoundedBox, Cylinder, Sphere } from "@react-three/drei";

export default function Router3D({ router, label: customName, secondary, testId = "router-label" }) {
  const group = useRef();

  useFrame((state) => {
    if (group.current) {
      group.current.rotation.y = Math.sin(state.clock.getElapsedTime() * 0.25) * 0.12;
    }
  });

  const label = customName || router?.model_label || "Router";

  return (
    <group ref={group}>
      {/* body */}
      <RoundedBox args={[1.7, 0.42, 1.1]} radius={0.12} smoothness={5} castShadow receiveShadow>
        <meshStandardMaterial color="#FFFFFF" roughness={0.25} metalness={0.1} />
      </RoundedBox>

      {/* status light */}
      <Sphere args={[0.06, 16, 16]} position={[0.65, 0.24, 0.4]}>
        <meshStandardMaterial color="#10B981" emissive="#10B981" emissiveIntensity={1.4} />
      </Sphere>
      <Sphere args={[0.05, 16, 16]} position={[0.45, 0.24, 0.4]}>
        <meshStandardMaterial color="#0055FF" emissive="#0055FF" emissiveIntensity={1.2} />
      </Sphere>

      {/* antennas */}
      {[-0.6, 0.6].map((x, i) => (
        <group key={i} position={[x, 0.2, -0.4]} rotation={[0, 0, x < 0 ? 0.25 : -0.25]}>
          <Cylinder args={[0.035, 0.035, 0.9, 12]} position={[0, 0.45, 0]} castShadow>
            <meshStandardMaterial color="#1F2937" roughness={0.4} />
          </Cylinder>
          <Sphere args={[0.06, 12, 12]} position={[0, 0.92, 0]}>
            <meshStandardMaterial color="#1F2937" />
          </Sphere>
        </group>
      ))}

      {/* label ABOVE the router */}
      <Html center distanceFactor={9} position={[0, 1.75, 0]} zIndexRange={[20, 0]}>
        <div
          data-testid={testId}
          dir="ltr"
          style={{ pointerEvents: "none" }}
          className="select-none whitespace-nowrap rounded-xl bg-white/95 px-3 py-1.5 text-center shadow-md ring-1 ring-[#0055FF]/15 backdrop-blur"
        >
          <div className="text-[10px] font-semibold uppercase tracking-wider text-[#0055FF]">
            {secondary ? "ראוטר · Sub-router" : "נתב · Router"}
          </div>
          <div className="max-w-[180px] truncate text-[13px] font-bold text-[#0A0A0A]">
            {label}
          </div>
          {router?.ip && (
            <div className="font-mono text-[10px] text-[#52525B]">{router.ip}</div>
          )}
        </div>
      </Html>
    </group>
  );
}
